module.exports = __webpack_public_path__ + "img/ASHRF_GIF.gif";